import { requestData } from "./request";

//埋点
export const buryingPoint = (data) => {
  return requestData("post", "/applet/AAUser/buryingPoint", data);
};

export const getZoneList = (data) => {
  return requestData("get", "/applet/ALogin/getTelephoneCodeList", data);
};

export const getFreezingModeList = (data) => {
  return requestData("get", "/applet/AAuction/getFreezingModeList", data);
};

// 获取当前热拍列表
export const getHotAuctionList = (data) => {
  return requestData("post", "/applet/AAuction/getHotAuctionList", data);
};
// 首页主题市场
export const getCategoryTree = (data) => {
  return requestData("get", "/common/CCategory/getCategoryTree", data);
};

// 首页行业资讯
// pageNo; //页码
// pageSize; //每页长度
// articleCategoryId; //咨询分类ID
export const articlePageList = (data) => {
  return requestData("get", "/applet/AArticle/articlePageList", data);
};
// 咨讯分类列表
export const articleCategoryList = (data) => {
  return requestData("get", "/applet/AArticle/articleCategoryList", data);
};
// 咨询详情
// id
export const articleDetailsById = (data) => {
  return requestData("get", "/applet/AArticle/articleDetailsById", data);
};
// 埋点接口
// id; //咨询ID
// type; //1-点赞，2-浏览
export const articleBuried = (data) => {
  return requestData("get", "/applet/AArticle/articleBuried", data);
};

// 账号密码注册
// {
//     type :  ,           //登录类型：1-账号密码登录，2-手机号,验证码登录
//     wxUser : {          //账户密码登录的时候传递
//         wxPhone : ,     //账号
//         userName : ,    //账号
//         password : ,    //密码
//     }
// }
export const register = (data) => {
  return requestData("post", "/applet/ALogin/register", data);
};

// 登录
// {
//     type :  ,           //登录类型：1-账号密码登录，2-手机号,验证码登录
//     wxUser : {          //账户密码登录的时候传递
//         userName : ,    //账号
//         password : ,    //密码
//     },
//     mobile : ,          //验证码登录的时候传递手机号
//     code : ,            //验证码登录的时候传递验证码

// {
//   "account":      ,       //账号（手机号）
//   "type":         ,       //登录类型：1 密码登录 , 2 手机号验证码登录
//   "password":     ,       //密码，登录类型为1时必传参数
//   "code":                 //验证码，登陆类型为2时必传参数
// }
// }
export const login = (data) => {
  return requestData("post", "/applet/ALogin/login", data);
};
// 获取验证码
// phone
export const getSMSVerificationCode = (data) => {
  return requestData("get", "/applet/ALogin/getSMSVerificationCode", data);
};

// 竞拍广场列表
// {
//     type : ,            //表头类型:1:进行中 2：已结束 3:流拍 4:即将开始 5:全部
//     dealType : ,        //货源或者订单 1是货源 2是订单
//     transactionType : , //竞拍类型 1是竞价 2是一口价 不传获取所有
//     category : "金枪鱼/大目/低温",   //品类品项规格名称以‘/’分隔
//     categoryType : ,    //原料或者半成品
//     pageNo : ,          //页码
//     pageSize :          //每页长度
// }
export const paimaiPageList = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionList", data);
};
//获取竞价/挂牌数量
export const getAuctionCount = (data) => {
  return requestData("get", "/applet/AAuction/getAuctionCount", data);
};
// 拍品详情
// id  竞拍ID
export const paimaiDetails = (data) => {
  return requestData("get", "/applet/AAuction2/auctionDetails", data);
};

// id  竞拍ID
export const screenDetails = (data) => {
  return requestData("post", "/httpClient/getDealDetailForChart", data);
};

//获取保证金余额 以及 相应冻结保证金
export const checkMarginAmount = (data) => {
  return requestData("post", "/applet/AAuction/checkMarginAmount", data);
};

// 报名
export const signUpAuction = (data) => {
  return requestData("post", "/applet/AAuction/applyAuction", data);
};

// 取消报名
// id  竞拍ID
export const cancelRegistration = (data) => {
  return requestData("get", "/applet/AAuction/cancelAuction", data);
};

// 设置提醒
// id  竞拍ID
export const setReminder = (data) => {
  return requestData("post", "/applet/AAuction/addOrCancelRemind", data);
};

// 历史出价
// id  竞拍ID
export const historyPrice = (data) => {
  return requestData("get", "/applet/AAuction/getAuctionOfferPriceList", data);
};

// 个人中心
// type 类型：竞拍成功-3，我参与的-2，我报名的5，我的需求-1
// pageNo 	页码
// pageSize 每页长度
export const myAllPage = (data) => {
  return requestData("get", "/auction/pc/myAllPage", data);
};

// 查询看货记录 根据竞拍id
// id  竞拍ID
export const getInspectionRecordDemandById = (data) => {
  return requestData("get", "/auction/pc/getInspectionRecordDemandById", data);
};

// 校验用户是否认证
export const getUserDetailsById = (data) => {
  return requestData("get", "/applet/user/getUserDetailsById", data);
};

// 获取客户信息
export const queryCustomerByUser = (data) => {
  return requestData("get", "/paimai/set/queryCustomerByUser", data);
};
// 出价
export const offerPrice = (data) => {
  return requestData("post", "/applet/AAuction/offerPrice", data);
};
// 轮播图
export const specialTitle = (data) => {
  return requestData("get", "/applet/ASpecial/queryAuctionSpecial", data);
};

// 识别身份证及营业执照
// imgPath 图片路径
// function 识别类型：1-身份证。2-营业执照 3组织机构+税务（营业执照15位要用）
// type 识别身份证时必须传type : face 正面 , back : 反面
export const OCRImageRecognition = (data) => {
  return requestData("get", "/applet/OCRImageRecognition", data);
};

// 用户认证
// {
//   "businessLicenseUrl": "",	//营业执照  type=2
//   "cardCopyUrl": "https://upload.huacaizhaoyu.com/upload_pic/91772a799db3410c8e562cc16814770c.jpg",  //身份证正面 type=1
//   "cardNationalUrl": "https://upload.huacaizhaoyu.com/upload_pic/9076493dc5e544808df3b5ad4806ee3d.jpg", //身份证返面 type=1
//   "city": "长治市",
//   "cityCode": "140400000000",
//   "contactName": "",  //联系人名称  type=2
//   "contactPhone": "15510435443", //联系人电话 type=2
//   "customerAppearance": "太平洋蓝鳍,黄鳍,条纹四鳍旗鱼",	//客户品项
//   "customerAttribute": "卖家",		//客户属性：买家    卖家     既是买家，也是卖家
//   "customerName": "奥巴马",		//客户名称
//   "customerType": "工厂",			//客户类型	工厂 批发商 餐饮店 个人
//   "district": "屯留区",
//   "districtCode": "140405000000",
//   "province": "山西省",
//   "provinceCode": "140000000000",
//   "street": "渔泽镇",
//   "streetCode": "140405102000",
//   "type": "1"   //认证类型：1-个人。2-企业
// }
export const userCertification = (data) => {
  return requestData("post", "/applet/user/certification", data);
};

// 上传图片接口
export const uploadPic = (data) => {
  return requestData("post", "/common/CUpload/uploadPic", data, "", {
    timeout: 1000 * 60 * 10,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// 上传图片接口返回name
export const uploadPdf = (data) => {
  return requestData("post", "/common/CUpload/uploadPdf", data, "", {
    "Content-Type": "multipart/form-data",
  });
};
// 经营品项
export const certificationCategoryList = (data) => {
  return requestData("get", "/applet/user/certificationCategoryList", data);
};

// {
//   "id":   ,   //竞拍/挂牌的ID
//   "tradeType":    ,   //交易类型
//   "category":     ,   //品类
//   "appearance":   ,   //品项
//   "specifications":   ,   //规格
//   "freezingMode":     ,   //冷冻方式
//   "unit":     ,   //单位
//   "weight":   ,   //重量
//   "locationCodes":    ,   //货源地址编码集，省市区县编码使用逗号分隔的字符串
//   "locationNames":    ,   //货源地址名称集，省市区名称码使用逗号分隔的字符串
// "addressDetail":   ,	//详细地址
//   "imgs":     ,   //货源图片，只有tradeType=2/4时才有
//   "sourceText":   ,   //货源描述，只有tradeType=2/4时才有
//   "scheduledDate":    ,   //竞拍日期，只有tradeType=1/2时才有
//   "scheduledTime":    ,   //竞拍时间，只有tradeType=1/2时才有
//   "scheduledDuration":    ,   //竞拍时长，只有tradeType=1/2时才有
//   "iprice":   ,   //竞价销售底价/一口价
//   "increments":   ,   //加价幅度，只有tradeType=1/2时才有
//   "freightBearer":    ,   //运费承担方
// }

export const publishAuction = (data) => {
  return requestData("post", "/applet/AAuction/publishAuction", data);
};

// 获取用户交易条件列表
export const getUserAuctionConditionList = (data) => {
  return requestData(
    "get",
    "/applet/ACommon/getUserAuctionConditionList",
    data
  );
};
// 获取用户交易条件列表
export const getRegionTree = (data) => {
  return requestData("get", "/common/CAuctionRegion/getRegionTree", data);
};
// 返回可选的竞价时间
export const queryAuctionSessions = (data) => {
  return requestData("get", "/applet/AAuction/queryAuctionSessions", data);
};
// 返回竞拍时长可选列表
export const queryAuctionDuration = (data) => {
  return requestData("get", "/applet/AAuction/queryAuctionDuration", data);
};

// 返回预计结束时间
export const getAuctionForecastEndTime = (data) => {
  return requestData("get", "/applet/AAuction/getAuctionForecastEndTime", data);
};

// 获取用户认证条件列表
export const getUserCertificationConditionList = (data) => {
  return requestData(
    "get",
    "/applet/ACommon/getUserCertificationConditionList",
    data
  );
};
// 开户信息查询
export const queryOpenAccount = (data) => {
  return requestData("get", "/applet/user/queryOpenAccount", data);
};
// 用户发布的交易列表
export const getUserPublishAuctionList = (data) => {
  return requestData("get", "/applet/AUser/getUserPublishAuctionList", data);
};

// 核对订单页
export const checkOrder = (data) => {
  return requestData("get", "/applet/AOrder/checkOrder", data);
};
// 核对订单页
export const queryOrderMakeUpAmount = (data) => {
  return requestData("get", "/applet/AOrder/queryOrderMakeUpAmount", data);
};
//生成订单
export const createOrder = (data) => {
  return requestData("get", "/applet/AOrder/createOrder", data);
};
//围网整单支付(首款和尾款通用)
export const purseSeinePayment = (data) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/purseSeinePayment",
    data
  );
};
//补交货款
export const makeUpAmountPayment = (data) => {
  return requestData("get", "/applet/AOrder/makeUpAmountPayment", data);
};

//生成订单
export const queryVirtualAccount = (data) => {
  return requestData("get", "/applet/user/queryVirtualAccount", data);
};

// 华采客服
export const customerService = (data) => {
  return requestData("get", "/applet/ACommon/customerService", data);
};
// 专属客服查询
export const getBusinessCard = (data) => {
  return requestData("get", "/applet/user/getBusinessCard", data);
};

// 我关注的
// type 1 代表 我报名的竞价，2 代表 我点赞的文章
// pageNo
// pageSize
export const getUserAttention = (data) => {
  return requestData("get", "/applet/AAUser/getUserAttention", data);
};
// 删除被驳回的交易
// id
export const deleteUserAuction = (data) => {
  return requestData("delete", "/applet/AUser/deleteUserAuction", data);
};
// 用户修改交易价格
// id
export const updateUserAuctionIprice = (data) => {
  return requestData("post", "/applet/AUser/updateUserAuctionIprice", data);
};
// 用户下架挂牌交易
// id
export const unshelveUserAuction = (data) => {
  return requestData("post", "/applet/AUser/unshelveUserAuction", data);
};
// 用户开户验证码银行卡验证持卡人手机号
export const getPersonalSmsCode = (data) => {
  return requestData("get", "/applet/user/getPersonalSmsCode", data);
};

export const openAccount = (data) => {
  return requestData("post", "/applet/user/openAccount", data);
};

// 全国银行列表查询
export const getBankList = (data) => {
  return requestData("get", "/applet/user/getBankList", data);
};

// 用户账户明细
export const accountTransactionDetails = (data) => {
  return requestData("get", "/applet/user/accountTransactionDetails", data);
};

// 用户钱包余额查询
export const getUserWalletAmount = (data) => {
  return requestData("get", "/applet/user/getUserWalletAmount", data);
};

//我的订单
export const getUserOrderList = (data) => {
  return requestData(
    "get",
    "/applet/ANewOrder/getNewOrderPageListByUser",
    data
  );
};
export const queryOrderDetails = (id) => {
  return requestData("get", "/applet/ANewOrder/newOrderDetails?id=" + id);
};
//用户保证金有效余额查询
export const getMarginAccount = (data) => {
  return requestData("get", "/applet/user/getMarginAccount", data);
};

// 用户保证金转入转出
// type 1 转入 ,2 转出
// amount 金额
export const inOrOutMargin = (data) => {
  return requestData("post", "/applet/user/inOrOutMargin", data);
};
// 用户余额提现
// amount 金额
export const userWithdrawal = (data) => {
  return requestData("post", "/applet/user/userWithdrawal", data);
};
//获取报名列表
export const getUserAuctionNoticeList = (data) => {
  return requestData("get", "/applet/AUser/getUserAuctionNoticeList", data);
};
//获取报名详情
export const getUserAuctionNoticeDetails = (data) => {
  return requestData("get", "/applet/AUser/getUserAuctionNoticeDetails", data);
};
//针对报名货源 确认/驳回操作
export const playApplyFixedPrice = (data) => {
  return requestData("post", "/applet/AAuction/playApplyFixedPrice", data);
};
//竞价-我报名的列表
export const getMyAuctionAppleList = (data) => {
  return requestData("get", "/applet/AAuction/getMyAuctionAppleList", data);
};
//竞价-我报名的详情
export const getMyAuctionAppleDetails = (data) => {
  return requestData("get", "/applet/AAuction/getMyAuctionAppleDetails", data);
};

//竞价-我报名的详情
export const getAuctionAppleDetails = (data) => {
  return requestData("get", "/applet/AAuction/getAuctionAppleDetails", data);
};
//编辑订单竞价/挂牌报名信息
export const editAuctionApply = (data) => {
  return requestData("post", "/applet/AAuction/editAuctionApply", data);
};
//编辑订单竞价/挂牌报名信息
export const deleteAuctionApple = (data) => {
  return requestData("post", "/applet/AAuction/deleteAuctionApple", data);
};
// 用户认证邀请码
// inviteCode
export const inviteCodeConfirm = (data) => {
  return requestData("post", "/applet/user/inviteCodeConfirm", data);
};

//验证入驻保证金是否大于10万
export const checkAccountBySource = (data) => {
  return requestData("get", "/applet/AAuction/checkAccountBySource", data);
};

// 开户账户换绑银行卡
// "smsCode": "999999",
// "mobile": "15294967282",
// "bankAcctNo":"6228480019079904777",
// "accountName":"腾金鱼",
// "bankCode":"兴业银行股份有限公司北京上地支行"
export const changeAccountBank = (data) => {
  return requestData("post", "/applet/user/changeAccountBank", data);
};
export const updateHeadImg = (data) => {
  return requestData("put", "/applet/user/updateHeadImg", data);
};
// 更改账户(手机号)
// account
// code
export const changeAccount = (data) => {
  return requestData("post", "/applet/user/changeAccount", data);
};

// 修改密码;
// password
export const updatePassWord = (data) => {
  return requestData("post", "/applet/AUser/user/updatePassWord", data);
};

//更改账户(手机号)-校验手机号是否存在,存在发送短信验证码
export const checkChangeAccount = (data) => {
  return requestData("get", "/applet/user/checkChangeAccount", data);
};

//查询闭市时间，用于首页判断开市闭市
export const distinguishTimes = (data) => {
  return requestData("get", "/applet/ACommon/distinguishTimes", data);
};
//查询闭市时间，用于首页判断开市闭市（新）
export const salmonDistinguishTimes = (data) => {
  return requestData("get", "/applet/ACommon/salmonDistinguishTimes", data);
};

//查询闭市时间，用于前端限制筛选
export const closingDateList = (data) => {
  return requestData("get", "/applet/AAuction/closingDateList", data);
};
//打款验证接口
export const paymentVerification = (data) => {
  return requestData("post", "/applet/user/paymentVerification", data);
};
//PC首页分类-竞价/挂牌列表
export const getCategoryAuctionList = (data) => {
  return requestData(
    "get",
    "/applet/AAuction/getHomeCategoryAuctionList",
    data
  );
};

export const querySystemNotice = (data) => {
  return requestData("get", "/applet/ACommon/querySystemNotice", data);
};
//获取个人中心首页的数量
export const getPersonalCenterQuantity = (data) => {
  return requestData("get", "/applet/AUser/getPersonalCenterQuantity", data);
};

export const downloadSignFile = (id) => {
  return requestData("get", "/applet/AContract/downloadSignFile?id=" + id);
};
export const downloadSupplementSignFile = (id) => {
  return requestData(
    "get",
    "/applet/AContract/downloadSupplementSignFile?id=" + id
  );
};

//仓单获取可选内容列表
export const getOptionList = (data) => {
  return requestData("get", "/applet/AWarehouseReceipt/getOptionList", data);
};

//创建或修改仓单
export const addOrUpdateWarehouseReceipt = (data) => {
  return requestData(
    "post",
    "/applet/AWarehouseReceipt/addOrUpdateWarehouseReceipt",
    data
  );
};
//原始仓单列表
export const getPrimevalWarehouseReceiptList = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getPrimevalWarehouseReceiptList",
    data
  );
};

//原始仓单详情
export const getPrimevalWarehouseReceiptDetail = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getPrimevalWarehouseReceiptDetail",
    data
  );
};
//仓单详情（通用）
export const getWarehouseReceiptItemDetail = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getWarehouseReceiptItemDetail",
    data
  );
};
//注册仓单
export const registerWarehouseReceipt = (data) => {
  return requestData(
    "post",
    "/applet/AWarehouseReceipt/registerWarehouseReceipt",
    data
  );
};

//注册仓单列表
export const getRegisterWarehouseReceiptList = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getRegisterWarehouseReceiptList",
    data
  );
};
//获取注册仓单详情
export const getRegisterWarehouseReceiptDetail = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getRegisterWarehouseReceiptDetail",
    data
  );
};
//注销仓单
export const logoffWarehouseReceipt = (data) => {
  return requestData(
    "post",
    "/applet/AWarehouseReceipt/logoffWarehouseReceipt",
    data
  );
};

//交收记录列表
export const getWarehouseReceiptSettlementRecordList = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getWarehouseReceiptSettlementRecordList",
    data
  );
};

//仓单审核记录列表
export const getWarehouseReceiptAuditList = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getWarehouseReceiptAuditList",
    data
  );
};
//获取仓单详情
export const getWarehouseReceiptDetail = (data) => {
  return requestData(
    "get",
    "/applet/AWarehouseReceipt/getWarehouseReceiptDetail",
    data
  );
};
//获取可选报关单列表
export const getCustomsDeclarationList = () => {
  return requestData("get", "/applet/AAuction2/getCustomsDeclarationList");
};

export const getRegisterWarehouseReceiptList1 = () => {
  return requestData(
    "get",
    "/applet/AAuction2/getRegisterWarehouseReceiptList"
  );
};

//发布竞价/挂牌
export const publishAuctionV2 = (data) => {
  return requestData("post", "/applet/AAuction2/publishAuction", data);
};

//缓存填写的交易信息
export const cacheAuction = (data) => {
  return requestData("post", "/applet/AAuction/cacheAuction", data);
};

//获取缓存的交易信息
export const getCacheAuction = (data) => {
  return requestData("get", "/applet/AAuction/getCacheAuction", data);
};

//发布交易存草稿功能
export const auctionDraft = (data) => {
  return requestData("post", "/applet/AAuction/auctionDraft", data);
};
//获取草稿详情功能
export const getAuctionDraftDetails = (data) => {
  return requestData("get", "/applet/AAuction/getAuctionDraftDetails", data);
};

//获取草稿列表功能
export const auctionDraftList = (data) => {
  return requestData("get", "/applet/AAuction/auctionDraftList", data);
};
//删除草稿功能
export const deletedAuctionDraft = (data) => {
  return requestData("delete", "/applet/AAuction/deletedAuctionDraft", data);
};

// 返回竞拍时长可选列表
export const getAuctionDurationList = (data) => {
  return requestData("get", "/applet/AAuction2/getAuctionDurationList", data);
};

// 取消订单
export const cancelOrder = (data) => {
  return requestData("get", "/applet/AOrder/cancelOrder", data);
};

// 签署合同
export const startSigningToLink = (data) => {
  return requestData("get", "/applet/AContract/startSigningToLink", data);
};

//补充协议发起签署 返回签署链接
export const startPonderationSigningToLink = (data) => {
  return requestData(
    "get",
    "/applet/AContract/startPonderationSigningToLink",
    data
  );
};

//设置支付密码
export const setPaymentPassword = (data) => {
  return requestData("post", "/applet/ANewOrder/setPaymentPassword", data);
};

//验证支付密码是否正确
export const checkingPaymentPassword = (data) => {
  return requestData("post", "/applet/ANewOrder/checkingPaymentPassword", data);
};

//货物状态更新 type == 1：发货，type == 2：收货
export const updateGoodsStatus = (data) => {
  return requestData("get", "/applet/ANewOrder/updateGoodsStatus", data);
};
//货物状态更新 type == 1：发货，type == 2：收货
export const newUpdateGoodsStatus = (data) => {
  return requestData("post", "/applet/ANewOrder/newUpdateGoodsStatus", data);
};

//支付仓单
export const paymentWarehouseReceipt = (data) => {
  return requestData("get", "/applet/ANewOrder/paymentWarehouseReceipt", data);
};
//获取排行榜时间筛选条件
export const getPublicRankingDateOptions = () => {
  return requestData("get", "/applet/ANewOrder/getPublicRankingDateOptions");
};
//获取公示排行列表
export const getPublicRankingList = (data) => {
  return requestData("get", "/applet/ANewOrder/getPublicRankingList", data);
};

//获取认证开户验证码
export const getAccountOpeningAuthenticationCode = (data) => {
  return requestData(
    "get",
    "/applet/AUserCertifiedAccountOpening/getAccountOpeningAuthenticationCode",
    data
  );
};

//保存或修改用户开户认证信息
export const saveUpdateUserCertifiedAccountOpening = (data) => {
  return requestData(
    "post",
    "/applet/AUserCertifiedAccountOpening/saveUpdateUserCertifiedAccountOpening",
    data
  );
};
//登记
export const AUserCertifiedAccountOpeningRegister = (data) => {
  return requestData(
    "post",
    "/applet/AUserCertifiedAccountOpening/register",
    data
  );
};

//获取认证开户验证码
export const getUserCertifiedAccountOpeningDetails = (data) => {
  return requestData(
    "get",
    "/applet/AUserCertifiedAccountOpening/getUserCertifiedAccountOpeningDetails",
    data
  );
};

//换绑银行卡获取验证码
export const getUpdateBankCartCode = (data) => {
  return requestData(
    "get",
    "/applet/AUserCertifiedAccountOpening/getUpdateBankCartCode",
    data
  );
};

//更改绑定银行卡
export const updateBankCard = (data) => {
  return requestData(
    "post",
    "/applet/AUserCertifiedAccountOpening/updateBankCard",
    data
  );
};
//校验当前账户是否有出售权限
export const checkSellSource = (data) => {
  return requestData("get", "/applet/AAuction/checkSellSource", data);
};

//获取账号关联信息
export const getAccountAssociationData = (data) => {
  return requestData(
    "get",
    "/applet/AccountAssociation/getAccountAssociationData",
    data
  );
};

//获取账号关联信息
export const getAddAccountAssociationCode = (data) => {
  return requestData(
    "get",
    "/applet/AccountAssociation/getAddAccountAssociationCode",
    data
  );
};
//添加或修改子账号
export const addOrUpdateAccountAssociation = (data) => {
  return requestData(
    "post",
    "/applet/AccountAssociation/addOrUpdateAccountAssociation",
    data
  );
};
//获取子账号详细信息
export const getAccountAssociationDetails = (data) => {
  return requestData(
    "get",
    "/applet/AccountAssociation/getAccountAssociationDetails",
    data
  );
};

//解绑关联账号
export const unbindAccountAssociation = (data) => {
  return requestData(
    "post",
    "/applet/AccountAssociation/unbindAccountAssociation",
    data
  );
};

//获取设置支付密码的验证码
export const getSetPaymentPasswordCode = (data) => {
  return requestData(
    "get",
    "/applet/ANewOrder/getSetPaymentPasswordCode",
    data
  );
};

//设置支付密码
export const setPaymentPassword1 = (data) => {
  return requestData("post", "/applet/ANewOrder/setPaymentPassword", data);
};

//发票-开票页列表
export const invoiceOrderPageList = (data) => {
  return requestData("get", "/applet/AInvoice/orderPageList", data);
};
//发票-提交开票信息确认页
export const confirmInvoiceDetails = (data) => {
  return requestData("get", "/applet/AInvoice/confirmInvoiceDetails", data);
};

//提交开票信息
export const subOrderInvoice = (data) => {
  return requestData("post", "/applet/AInvoice/subOrderInvoice", data);
};

//重新发送
export const resendInvoice = (data) => {
  return requestData("post", "/applet/AInvoice/resendInvoice", data);
};

//发票-开票详情
export const orderInvoiceDetails = (data) => {
  return requestData("get", "/applet/AInvoice/orderInvoiceDetails", data);
};

//已开票列表
export const orderInvoicePage = (data) => {
  return requestData("get", "/applet/AInvoice/orderInvoicePage", data);
};

//添加关注/取消关注
export const addAuctionCare = (data) => {
  return requestData("post", "/applet/ACare/addAuctionCare", data);
};

//关注的交易列表
export const careAuctionInfoPageList = (data) => {
  return requestData("get", "/applet/ACare/careAuctionInfoPageList", data);
};

//待提交的交易
export const waitSubmitAuction = (data) => {
  return requestData("get", "/applet/AAuction2/waitSubmitAuction", data);
};

//取消提交
export const cancelSubmitAuction = (data) => {
  return requestData("get", "/applet/AAuction2/cancelSubmitAuction", data);
};
export const queryOrderPayStatus = (id) => {
  return requestData("get", "/applet/AOrder/queryOrderPayStatus?id=" + id);
};

export const sendOpenAccountAgreement = () => {
  return requestData(
    "put",
    "/applet/AUserCertifiedAccountOpening/sendOpenAccountAgreement"
  );
};

export const getBrandList = () => {
  return requestData("get", "/applet/AAuction/getBrandList");
};
export const getBrand = (id) => {
  return requestData("get", "/applet/AAuction/getBrand?id=" + id);
};

export const checkInOrOutMargin = () => {
  return requestData("get", "/applet/user/checkInOrOutMargin");
};

export const getSpecialAuctionList = (data) => {
  return requestData("post", "/applet/AAuction/getSpecialAuctionList", data);
};

export const querySplitOrder = (id) => {
  return requestData("get", "/applet/AOrder/querySplitOrder?orderId=" + id);
};
export const splitOrder = (id, num) => {
  return requestData(
    "get",
    "/applet/AOrder/splitOrder?orderId=" + id + "&splitCount=" + num
  );
};
//取消拆单
export const cancelSplitOrder = (data) => {
  return requestData("delete", "/applet/AOrder/cancelSplitOrder", data);
};
//刷新拆单
export const querySplitOrderPayStatus = (id) => {
  return requestData("get", "/applet/AOrder/querySplitOrderPayStatus?id=" + id);
};

export const splitOrderPay = (data) => {
  return requestData("post", "/applet/AOrder/splitOrderPay", data);
};

export const confirmPayment = (id) => {
  return requestData("get", "/applet/AOrder/confirmPayment?orderId=" + id);
};

//获取交易弹窗
export const getAuctionNoticePopup = (id) => {
  return requestData("get", "/applet/AAuction2/getAuctionNoticePopup?id=" + id);
};

//确认已读弹窗
export const confirmAuctionNoticePopup = (id) => {
  return requestData(
    "get",
    "/applet/AAuction2/confirmAuctionNoticePopup?id=" + id
  );
};
//确认拆单
export const confirmationSplitOrder = (orderId) => {
  return requestData(
    "get",
    "/applet/AOrder/confirmationSplitOrder?orderId=" + orderId
  );
};
//获取交易数量
export const getAuctionInfoCount = (data) => {
  return requestData("post", "/applet/AAuction/getAuctionInfoCount", data);
};
//服务申请获取验证码
export const getServiceApplyCode = (data) => {
  return requestData("get", "/applet/AServiceApply/getServiceApplyCode", data);
};
//服务申请
export const serviceApply = (data) => {
  return requestData("post", "/applet/AServiceApply/serviceApply", data);
};
//个人中心统计数据
export const getPersonalCenterQuantity2 = () => {
  return requestData("get", "/applet/AUser/getPersonalCenterQuantity2");
};
//
export const downloadOtherBankReceipt = (id) => {
  return requestData(
    "get",
    "/applet/AOrder/downloadOtherBankReceipt?orderId=" + id
  );
};
//保证金转入列表查询
export const inOrOutMarginList = () => {
  return requestData("get", "/applet/user/inOrOutMarginList");
};

//保证金转入列表查询
export const GoInToMargin = (id) => {
  return requestData("get", "/applet/user/GoInToMargin?id=" + id);
};

//保证金取消转入列表查询
export const cancelTransferMargin = (id) => {
  return requestData("get", "/applet/user/cancelTransferMargin?id=" + id);
};

//查询数据
export const queryGoodsDataDisplay = (type) => {
  return requestData(
    "get",
    "/applet/AAuction/queryGoodsDataDisplay?type=" + type
  );
};
//获取企业列表
export const getUserOpenAccountList = (type) => {
  return requestData("get", "/applet/user/getUserOpenAccountList");
};
//设置当前使用企业
export const setCurrentEnterprise = (id) => {
  return requestData(
    "post",
    "/applet/user/setCurrentEnterprise?accountId=" + id
  );
};

//获取搜索历史列表
export const getSearchList = () => {
  return requestData("get", "/applet/AAuction/getSearchList");
};
//删除搜索历史
export const deletedSearchById = (data) => {
  return requestData("post", "/applet/AAuction/deletedSearchById", data);
};

//获取银行卡列表
export const getUserEnterpriseBankCardList = (type) => {
  return requestData(
    "get",
    "/applet/user/getUserEnterpriseBankCardList?isScreen=" + type
  );
};
//新增账户
export const addEnterpriseAccount = (data) => {
  return requestData("post", "/applet/user/addEnterpriseAccount", data);
};

//获取银行卡列表
export const logoutEnterpriseAccount = (id) => {
  return requestData("delete", "/applet/user/logoutEnterpriseAccount?id=" + id);
};

//保证金转入记录
export const queryInOrOutMarginRecordList = (type) => {
  return requestData("get", "/applet/user/queryInOrOutMarginRecordList");
};
//设置默认账户
export const setEnterpriseDefaultAccount = (data) => {
  return requestData("post", "/applet/user/setEnterpriseDefaultAccount", data);
};

//发布交易-暂停提交
export const pauseSubmitAuction = (id) => {
  return requestData("get", "/applet/AAuction2/pauseSubmitAuction?id=" + id);
};
//计算货值(设置交割时候显示货款总价值)
export const purseSeineGoodsAmount = (data) => {
  return requestData(
    "post",
    "/applet/purseSeinerInventory/purseSeineGoodsAmount",
    data
  );
};
//计算比例金额
export const computingTheFirst = (params) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/computingTheFirst",
    params
  );
};

//发起尾款查询预估吨数单价
export const initialBalance = (id) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/initialBalance?orderId=" + id
  );
};
//核对尾款信息
export const checkBalance = (params) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/checkBalance",
    params
  );
};
//计算单价
export const purseSeineCalculateUnitPrice = (params) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/purseSeineCalculateUnitPrice",
    params
  );
};
//确认发起尾款
export const purseSeineConfirmationInitialBalance = (data) => {
  return requestData(
    "post",
    "/applet/purseSeinerInventory/purseSeineConfirmationInitialBalance",
    data
  );
};
//尾款延期
export const purseSeineDelay = (data) => {
  return requestData(
    "post",
    "/applet/purseSeinerInventory/purseSeineDelay",
    data
  );
};
//查询结算单
export const queryBalanceInfo = (id) => {
  return requestData(
    "get",
    "/applet/purseSeinerInventory/queryBalanceInfo?orderId=" + id
  );
};

//多规格相关
//多规格发布竞价接口
export const moreSpecPublishAuction = (data) => {
  return requestData("post", "/applet/moreSpecifications/publishAuction", data);
};
//竞价时间接口
export const moreSpecQueryBalanceInfo = (scheduledDate) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/getAuctionTime?scheduledDate=" + scheduledDate
  );
};
//竞价时间接口
export const getAuctionStartTime = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/getAuctionStartTime",
    params
  );
};
//根据竞拍日期+竞拍开始时间 获取结束时间
export const getAuctionEndTime = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/getAuctionEndTime",
    params
  );
};
//报名须知
export const getSignUpNotes = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/getSignUpNotes",
    params
  );
};
//报名接口
export const moreSpecApplyAuction = (data) => {
  return requestData("post", "/applet/moreSpecifications/applyAuction", data);
};
//取消报名
export const moreSpecCancelApplyAuction = (data) => {
  return requestData(
    "post",
    "/applet/moreSpecifications/cancelApplyAuction",
    data
  );
};
//竞价出价弹窗
export const auctionOfferPrice = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/auctionOfferPrice",
    params
  );
};
//查询当前出价最高价
export const queryCurrentHighPrice = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/queryCurrentHighPrice",
    params
  );
};
//多规格出价接口
export const moreSpecOfferPrice = (data) => {
  return requestData("post", "/applet/moreSpecifications/offerPrice", data);
};
//出价查看详情接口
export const queryOfferPriceDetails = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/queryOfferPriceDetails",
    params
  );
};

//出价计算总金额
export const offerPriceCalculateAmount = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/offerPriceCalculateAmount",
    params
  );
};

//所属银行
export const getOptionalBankList = () => {
  return requestData("get", "/applet/openAccount/getOptionalBankList");
};
//又拍云获取密钥
export const getMd5Password = (params) => {
  return requestData("get", "/applet/getMd5Password", params);
};

//查询合同详情
export const queryOrderContractDetails = (params) => {
  return requestData(
    "get",
    "/applet/ANewOrder/queryOrderContractDetails",
    params
  );
};
//卖家发起签署
export const initiateContractAmendments = (params) => {
  return requestData(
    "get",
    "/applet/AContract/initiateContractAmendments",
    params
  );
};
//买家合同修订签署（pc）
export const startSigningAmendment = (params) => {
  return requestData("get", "/applet/AContract/startSigningAmendment", params);
};
//自捕鱼-查看补充协议
export const downloadAmendmentSignFile = (id) => {
  return requestData(
    "get",
    "/applet/AContract/downloadAmendmentSignFile?orderId=" + id
  );
};
//自捕鱼---发起尾款查询交易详情
export const sellerInitiateRetainage = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/sellerInitiateRetainage",
    params
  );
};
//自捕鱼---计算尾款支付或者退回
export const sellerCheckRetainage = (data) => {
  return requestData(
    "post",
    "/applet/moreSpecifications/sellerCheckRetainage",
    data
  );
};
//自捕鱼---确认发起尾款
export const sellerConfirmationRetainage = (data) => {
  return requestData(
    "post",
    "/applet/moreSpecifications/sellerConfirmationRetainage",
    data
  );
};
//自捕鱼---确认交货港口
export const confirmArrivalGoodsPort = (params) => {
  return requestData(
    "get",
    "/applet/ANewOrder/confirmArrivalGoodsPort",
    params
  );
};
//自捕鱼---校验时段
export const checkAuctionEndTime = (params) => {
  return requestData(
    "get",
    "/applet/moreSpecifications/checkAuctionEndTime",
    params
  );
};

//三文鱼相关接口
//获取产地信息
export const getSalmonProducerList = (params) => {
  return requestData("get", "/applet/ASalmon/getSalmonProducerList", params);
};
//根据产地获取品牌信息
export const getSalmonProducerBrand = (params) => {
  return requestData("get", "/applet/ASalmon/getSalmonProducerBrand", params);
};
//根据产地获取厂号列表
export const getSalmonProducerFactoryNo = (params) => {
  return requestData(
    "get",
    "/applet/ASalmon/getSalmonProducerFactoryNo",
    params
  );
};
//三文鱼核对订单页
export const salmonCheckOrder = (params) => {
  return requestData("get", "/applet/AOrder/salmonCheckOrder", params);
};
//挂牌确认购买生成订单（只针对挂牌）
export const salmonCreateOrder = (params) => {
  return requestData("get", "/applet/AOrder/salmonCreateOrder", params);
};

//三文鱼挂牌支付确认
export const salmonConfirmationPayment = (params) => {
  return requestData("get", "/applet/AOrder/salmonConfirmationPayment", params);
};

//挂牌订单支付（只针对挂牌）
export const salmonPaymentOrder = (params) => {
  return requestData("get", "/applet/AOrder/salmonPaymentOrder", params);
};

//三文鱼订单核对总重量
export const salmonCheckTotalWeight = (params) => {
  return requestData("get", "/applet/ANewOrder/salmonCheckTotalWeight", params);
};
//三文鱼确认总重量
export const salmonAffirmTotalWeight = (data) => {
  return requestData("post", "/applet/ANewOrder/salmonAffirmTotalWeight", data);
};
//三文鱼确认总重量
export const checkSalmonSellerMargin = (params) => {
  return requestData("get", "/applet/AAuction/checkSalmonSellerMargin", params);
};
//海外专区
//获取条件列表
export const foreignGetOptionList = (params) => {
  return requestData("get", "/applet/foreignAuction/getOptionList", params);
};
//企业信息缓存接口
export const cacheEnterpriseCertificationInfo = (data) => {
  return requestData(
    "post",
    "/applet/certifiedForeignEnterprise/cacheEnterpriseCertificationInfo",
    data
  );
};
//企业信息缓存接口
export const enterpriseCertification = (data) => {
  return requestData(
    "post",
    "/applet/certifiedForeignEnterprise/enterpriseCertification",
    data
  );
};
//查询缓存企业信息
export const queryCacheEnterpriseCertificationInfo = (params) => {
  return requestData(
    "get",
    "/applet/certifiedForeignEnterprise/queryCacheEnterpriseCertificationInfo",
    params
  );
};
//查询缓存企业信息
export const queryEnterpriseCertification = (params) => {
  return requestData(
    "get",
    "/applet/certifiedForeignEnterprise/queryEnterpriseCertification",
    params
  );
};
//发送验证码
export const checkChangeAccountCode = (data) => {
  return requestData("get", "/applet/user/checkChangeAccount", data);
};
//变更绑定手机号或者邮箱
export const changeAccountOverseas = (data) => {
  return requestData("post", "/applet/user/changeAccount", data);
};
//货源产地列表
export const getProducerList = (data) => {
  return requestData("get", "/applet/foreignAuction/getProducerList", data);
};

//发布竞拍
export const releaseAuctionInfoForeign = (data) => {
  return requestData(
    "post",
    "/applet/foreignAuction/releaseAuctionInfoForeign",
    data
  );
};
//我的货源
export const queryMySourceList = (data) => {
  return requestData("get", "/applet/foreignAuction/queryMySourceList", data);
};

//竞拍详情接口
export const getAuctionInfoForeignDetailsById = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/getAuctionInfoForeignDetailsById",
    data
  );
};

//我的货源下架
export const auctionInfoForeignOffShelf = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/auctionInfoForeignOffShelf",
    data
  );
};

//英文专区-货源列表
export const getAuctionInfoForeignList = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/getAuctionInfoForeignList",
    data
  );
};
//查询我的代理货源
export const queryAgentSourceGoodsList = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/queryAgentSourceGoodsList",
    data
  );
};
//发布查询可选代理货源
export const releaseSelectAgentSource = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/releaseSelectAgentSource",
    data
  );
};
//发布货源-查询代理货源编号品名
export const queryAgentSourceGoodsInfo = (data) => {
  return requestData(
    "get",
    "/applet/foreignAuction/queryAgentSourceGoodsInfo",
    data
  );
};

//延时字典数据
export const auctionTimeDelayDictionary = (params) => {
  return requestData(
    "get",
    "/applet/AAuction2/auctionTimeDelayDictionary",
    params
  );
};
//订单上传凭证
export const uploadPaymentVoucher = (data) => {
  return requestData("post", "/applet/ANewOrder/uploadPaymentVoucher", data);
};
//查询买卖家信息
export const queryCustomerList = (params) => {
  return requestData("get", "/applet/AAuction2/queryCustomerList", params);
};

//生成订单
export const manuallyCreatingOrders = (data) => {
  return requestData("post", "/applet/AAuction2/manuallyCreatingOrders", data);
};

//查询税率列表
export const queryTaxRateList = (params) => {
  return requestData("get", "/applet/AAuction/queryTaxRateList", params);
};
//查询税率列表
export const queryPlatformPopover = () => {
  return requestData("get", "/applet/ACommon/queryPlatformPopover");
};
//交货方式及运输列表
export const queryFreightBearerList = () => {
  return requestData("get", "/applet/ACommon/queryFreightBearerList");
};
//交货方式及运输列表
export const getEnterpriseLibrarianList = () => {
  return requestData(
    "get",
    "/applet/AUserCertifiedAccountOpening/getEnterpriseLibrarianList"
  );
};

//成品专区
export const getFinishedCategoryTree = (data) => {
  return requestData("get", "/common/CCategory/getFinishedCategoryTree", data);
};
//成品-计算货值(设置交割时候显示货款总价值)
export const goodsAmount = (data) => {
  return requestData("post", "/applet/finishedProduct/goodsAmount", data);
};
//获取规则列表
export const getPlatformRulesList = (data) => {
  return requestData("get", "/applet/ACommon/getPlatformRulesList", data);
};
//售后相关
//退款申请详情
export const afterSalesApplication = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/afterSalesApplication",
    params
  );
};
//计算服务费
export const calculatingServiceCharges = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/calculatingServiceCharges",
    params
  );
};
//发起售后申请
export const initiateRefundApplication = (data) => {
  return requestData(
    "post",
    "/applet/AOrderRefund/initiateRefundApplication",
    data
  );
};
//我的售后列表
export const getMineOrderRefundList = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/getMineOrderRefundList",
    params
  );
};
//我的售后列表计数
export const getMineOrderRefundListCount = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/getMineOrderRefundListCount",
    params
  );
};

//退货详情
export const getMineOrderRefundDetailsById = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/getMineOrderRefundDetailsById",
    params
  );
};
//签署解除协议
export const signatureDischargeProtocol = (params) => {
  return requestData(
    "put",
    "/applet/AOrderRefund/signatureDischargeProtocol",
    params
  );
};
//提交处理意见
export const processingAfterSalesApplication = (data) => {
  return requestData(
    "post",
    "/applet/AOrderRefund/processingAfterSalesApplication",
    data
  );
};
//去退款
export const goRefund = (params) => {
  return requestData("put", "/applet/AOrderRefund/goRefund", params);
};
//核对退款金额
export const checkRefundAmount = (params) => {
  return requestData("get", "/applet/AOrderRefund/checkRefundAmount", params);
};
//撤销售后申请
export const withdrawalApplication = (params) => {
  return requestData(
    "get",
    "/applet/AOrderRefund/withdrawalApplication",
    params
  );
};
//撤销售后申请
export const queryBiddingNoticeList = (params) => {
  return requestData("get", "/applet/AAuction/queryBiddingNoticeList", params);
};
//获取对账单列表
export const getNewOrderExcelByUser = (data) => {
  return requestData(
    "post",
    "/applet/ANewOrder/getNewOrderExcelByUser",
    data,
    "blob"
  );
};
//订单详情-价格隐藏
export const orderSelfFishingPriceHiding = (params) => {
  return requestData(
    "put",
    "/applet/ANewOrder/orderSelfFishingPriceHiding",
    params
  );
};
//深圳远洋自捕
//撤销发布
export const undoPublishAuction = (params) => {
  return requestData("get", "/applet/AUser/undoPublishAuction", params);
};
export const queryAuctionOnlookers = (params) => {
  return requestData("get", "/applet/AAuction2/queryAuctionOnlookers", params);
};
export const queryAuctionSignUpUserList = (params) => {
  return requestData(
    "get",
    "/applet/AAuction2/queryAuctionSignUpUserList",
    params
  );
};
//议价相关功能
export const getAuctionNoticePopup2 = (params) => {
  return requestData("get", "/applet/AAuction2/getAuctionNoticePopup", params);
};
export const confirmAuctionNoticePopup2 = (params) => {
  return requestData(
    "get",
    "/applet/AAuction2/confirmAuctionNoticePopup",
    params
  );
};
//发起议价
export const auctionPriceNegotiation = (data) => {
  return requestData("post", "/applet/AAuction2/auctionPriceNegotiation", data);
};
export const queryAuctionPriceNegotiationList = (params) => {
  return requestData(
    "get",
    "/applet/AAuction2/queryAuctionPriceNegotiationList",
    params
  );
};
export const auctionPriceNegotiationAudit = (params) => {
  return requestData(
    "put",
    "/applet/AAuction2/auctionPriceNegotiationAudit",
    params
  );
};
//图形验证字符串
export const generateCAPtchas = (data) => {
  return requestData("post", "/applet/ALogin/generateCAPtchas", data);
};
export const getSMSRegistrationVerificationCode = (params) => {
  return requestData(
    "get",
    "/applet/ALogin/getSMSRegistrationVerificationCode",
    params
  );
};
export const queryPassWordExpired = () => {
  return requestData("get", "/applet/AUser/queryPassWordExpired");
};

export const getBackPasswordSendEmailCode = (data) => {
  return requestData(
    "post",
    "/applet/ALogin/getBackPasswordSendEmailCode",
    data
  );
};
export const verifyEmailCode = (data) => {
  return requestData("post", "/applet/ALogin/verifyEmailCode", data);
};
export const resetPassword = (data) => {
  return requestData("post", "/applet/ALogin/resetPassword", data);
};
export const queryOrderUploadAttachment = (params) => {
  return requestData(
    "get",
    "/applet/ANewOrder/queryOrderUploadAttachment",
    params
  );
};

export const orderUploadAttachment = (data) => {
  return requestData("post", "/applet/ANewOrder/orderUploadAttachment", data);
};

export const undoDataCompletion = (params) => {
  return requestData("put", "/applet/ANewOrder/undoDataCompletion", params);
};
export const queryWhitelistCustomerList = (data) => {
  return requestData(
    "post",
    "/applet/moreSpecifications/queryWhitelistCustomerList",
    data
  );
};
//鱼货列表品类品项规格列表树
export const getLcCategoryTree = (type) => {
  return requestData("get", "/common/CCategory/getLcCategoryTree");
};

export const initiatePaymentGoods = (data) => {
  return requestData("post", "/applet/ANewOrder/initiatePaymentGoods", data);
};



// WEBPACK FOOTER //
// ./src/request/api.js